import { useQuery } from 'react-query';
import { useCookies } from 'react-cookie';
import { useHeaderFilters } from 'context/GlobalFiltersContext';
import { AgendaService } from 'services/reports/endpoints/AgendaService';
import type { AgendaTarefasResponse } from 'services/reports/endpoints/AgendaService';

interface UseAgendaTarefasParams {
  aplicacaoPlanoAtividadeId: number;
  primeiraDataHora: string;
  status: 0 | 1;
}

export const useAgendaTarefas = ({ aplicacaoPlanoAtividadeId, primeiraDataHora, status }: UseAgendaTarefasParams) => {
  const [cookie] = useCookies();
  const { headerFiltersContext } = useHeaderFilters();
  const { headerFilters } = headerFiltersContext;

  const empresaId = cookie.companies?.id ? Number(cookie.companies.id) : undefined;
  const unidadeId = headerFilters?.units?.id ? Number(headerFilters.units.id) : undefined;

  return useQuery<AgendaTarefasResponse>(
    ['agendaTarefas', aplicacaoPlanoAtividadeId, primeiraDataHora, status, empresaId, unidadeId],
    () =>
      AgendaService.getAgendaTarefas({
        aplicacaoPlanoAtividadeId,
        data: primeiraDataHora,
        status,
        empresaId,
        unidadeId,
      }).then(res => res.data),
    { staleTime: 1000 * 60 },
  );
};
